// Polls the per-tenant SRI breaker state and shows a sticky banner when OPEN.
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../api.js';
import { useAuth } from '../../auth/AuthProvider.js';

interface State {
  state: 'CLOSED' | 'OPEN' | 'HALF_OPEN';
}

export function ContingenciaBanner() {
  const { t } = useTranslation('bookkeeping');
  const { activeOrgId } = useAuth();
  const { data } = useQuery({
    queryKey: ['sri-contingencia', activeOrgId],
    queryFn: () => api<State>('/bookkeeping/sri/contingencia-state'),
    enabled: !!activeOrgId,
    refetchInterval: 60_000,
  });
  if (!data || data.state !== 'OPEN') return null;
  return (
    <div className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900">
      <strong className="font-semibold">{t('sri.contingencia_banner.title')}: </strong>
      {t('sri.contingencia_banner.body')}
    </div>
  );
}
